<template>
  <div>
    <div class="navbar navbar-dark bg-dark">
      <a href="/">
        <img src="/logo-text-small.png" alt="logo" />
      </a>
    </div>
    <error-panel showInPopup="false"/>
  </div>
</template>

<script>
import ErrorPanel from "@/components/ErrorPanel";
export default {
  name: "EmbeddedHeader",
  components: {
    ErrorPanel
  }
}
</script>

<style scoped>

</style>
